import React from 'react';

export default () => (
  <svg width="70" height="50" viewBox="-1 -1 72 52" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <g fill="#D6DCE4">
        <g>
          <path d="M.5.5h30.32v20.319H.5zM39.207.5h30.32v20.319h-30.32zM.5 29.5h30.32v20.319H.5zM39.207 29.5h30.32v20.319h-30.32z" />
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/media-previews-widget.es6.js